import { useCallback } from 'react'
import {
  ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	cancerApi,
	dpcApi,
	sisetuApiBy,
} from 'interface/endpoints'
import {
	CancerDiseaseResult,
	CancerDiseaseResultList,
	CancerStageClassResult,
	CancerStageClassResultList, 
	CancerResultList,
	CancerStatsResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListCancerDisease = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<CancerDiseaseResultList>(
        apiAccess,
				cancerApi('/disease/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useGetCancerDisease = (
	diseaseCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!diseaseCode) return null
      return ApiGetWithToken<CancerDiseaseResult>(
        apiAccess,
				cancerApi(`/disease/${diseaseCode}`, { t }),
        cancelToken
      )
    },
		[diseaseCode]
	)
)

export const useListCancerStageClass = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<CancerStageClassResultList>(
        apiAccess,
				dpcApi('/stageClass/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useGetCancerStageClass = (
	stageClassCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!stageClassCode) return null
      return ApiGetWithToken<CancerStageClassResult>(
        apiAccess,
				cancerApi(`/stageClass/${stageClassCode}`, { t }),
        cancelToken
      )
    },
		[stageClassCode]
	)
)

export const useGetCancerResultBySisetu = (
	sisetuCode: string | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!sisetuCode) return null
      return ApiGetWithToken<CancerResultList>(
        apiAccess,
				sisetuApiBy(sisetuCode, '/cancer', { t }),
        cancelToken
      )
    },
		[sisetuCode]
	)
)

export const useGetCancerStats = (
	diseaseCode: string | null | undefined,
	stageClassCode: string | null | undefined
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!diseaseCode || !stageClassCode) return null
      return ApiGetWithToken<CancerStatsResultList>(
        apiAccess,
				cancerApi(`/stats/${diseaseCode}/${stageClassCode}`, { t }),
        cancelToken
      )
    },
		[diseaseCode, stageClassCode]
	)
)
